__turbopack_context__.v({
  "author": "ArticleModuleTeaser-module-scss-module__Y44zPW__author",
  "authorImage": "ArticleModuleTeaser-module-scss-module__Y44zPW__authorImage",
  "authorName": "ArticleModuleTeaser-module-scss-module__Y44zPW__authorName",
  "authorSection": "ArticleModuleTeaser-module-scss-module__Y44zPW__authorSection",
  "authorSectionAuthors": "ArticleModuleTeaser-module-scss-module__Y44zPW__authorSectionAuthors",
  "authorSectionVon": "ArticleModuleTeaser-module-scss-module__Y44zPW__authorSectionVon",
  "breadcrumb": "ArticleModuleTeaser-module-scss-module__Y44zPW__breadcrumb",
  "breadcrumbArrow": "ArticleModuleTeaser-module-scss-module__Y44zPW__breadcrumbArrow",
  "breadcrumbHeadline": "ArticleModuleTeaser-module-scss-module__Y44zPW__breadcrumbHeadline",
  "homeIcon": "ArticleModuleTeaser-module-scss-module__Y44zPW__homeIcon",
  "meta": "ArticleModuleTeaser-module-scss-module__Y44zPW__meta",
  "playing": "ArticleModuleTeaser-module-scss-module__Y44zPW__playing",
  "publicationDate": "ArticleModuleTeaser-module-scss-module__Y44zPW__publicationDate",
  "sourceOrigin": "ArticleModuleTeaser-module-scss-module__Y44zPW__sourceOrigin",
  "title": "ArticleModuleTeaser-module-scss-module__Y44zPW__title",
  "wrapper": "ArticleModuleTeaser-module-scss-module__Y44zPW__wrapper",
});
